// extracted by mini-css-extract-plugin
export default {"root":"GroupsContestSummary_root__hgJdr"};